<div class="ne-header">
  {#if logoSrc}
    <img alt="logo" class="ne-logo" src={logoSrc} />
  {:else}
    <span></span>
  {/if}
  <CloseButton click="{close}"/>
</div>

<style>
  .ne-header {
    display: flex;
    justify-content: space-between;
  }

  .ne-logo {
    align-self: center;
  }
</style>

<script>
  import CloseButton from './CloseButton.html';

  export let logoSrc;
  export let close;
</script>
